import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useHistory,
  useLocation
} from "react-router-dom";



export class Logout extends Component {
  static displayName = Logout.name;

  render ()
   {
    const { from } = { from: { pathname: '/' } };
    localStorage.setItem('token',null);
    return (
        <Redirect to={from} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Logout.js